import React from 'react';
import Slider from 'react-slick';
import fcoImage from '../assets/fco.png';
import tomasImage from '../assets/tomas.png';
import diegoImage from '../assets/diego.png';
import guillermoImage from '../assets/guillermo.png';

export const TeamUser = ({user}) => {
	var bgImage =
    (typeof user.imageId === 'string' || user.imageId instanceof String) &&
    user.imageId.length === 36
      ? `https://outlier-spa.github.io/EstudioPinedaWeb/${user.imageId}.png`
      : user.imageId;
	return (
		<div className="team__user traf">
			<div className={`user__inner`}>
				<div className="user_image">
					<div className="bg-cover traf" style={{backgroundImage: `url(${bgImage})`}}></div>
				</div>
				<div className="user_info">
					<h4>{user.names}</h4>
					<h5 style={{color: user.color}}>{user.position}</h5>
					<div className="user_description">
						{user.description}
						{/* {user.items.map((item, k) => (
							<div key={k}>{item}</div>
						))} */}
					</div>
					<a href={`mailto:${user.email}`}><i className="icon-mail"></i> {user.email}</a>
				</div>
			</div>
		</div>
	);
}

const arrayUsers = [
	{
		names: 'Francisco Pineda Peña',
		position: 'Abogado Fundador',
		email: 'pineda.p.francisco@gmail.com',
		items: [
			'Especialista en Derecho de Familia y Derecho Civil.',
			'Masterando en Derecho de Familia.'
		],
		imageId: fcoImage
	},
	{
		names: 'Tomás Sepúlveda Muñoz',
		position: 'Abogado Asociado',
		email: 'tomas.sepulveda@estudiopineda.cl',
		items: [
			'Especialista en Derecho de Familia',
			'Licenciado en Ciencias Jurídicas y Sociales.'
		],
		imageId: tomasImage
	},
	{
		names: 'Guillermo Tejo Jara',
		position: 'Abogado Asociado',
		email: 'guillermo.tejo@estudiopineda.cl',
		items: [
			'Especialista en Derecho de Familia',
			'Licenciado en Ciencias Jurídicas y Sociales.'
		],
		imageId: guillermoImage
	},
	{
		names: 'Diego Alarcón Delgado',
		position: 'Administrativo',
		email: 'contacto@estudiopineda.cl',
		items: [
			'Estudiante Ingeniería Civil Industrial'
		],
		imageId: diegoImage
	},
];

arrayUsers.map(u => u.description = u.items.join('\n'));

export default class Team extends React.Component {
	static defaultProps = { title: 'Profesionales a su disposición', users: arrayUsers };
	settings = {
		dots: true,
		arrows: false,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		// slidesToScroll: 1,
		centerMode: true,
  	variableWidth: true,
		initialSlide: 0,
		autoplay: true,
		autoplaySpeed: 5000,
		responsive: [
			{
				breakpoint: 680,
				adaptiveHeight: true,
				settings: {
					slidesToScroll: 1,
					slidesToShow: 1,
					variableWidth: false
				}
			}
		]
	};

	render(){
		var { title, users } = this.props;
		return (
			<section className="section__team">
				{/* <div className="inner__section"> */}
					<div className="center-text">
						<h2 className="section__title small in_view_animate">{title}</h2>
					</div>
					<Slider {...this.settings}>
						{users.map((user, k) => (
							<TeamUser key={k} user={user} />
						))}
					</Slider>
				{/* </div> */}
			</section>
		);
	}
}
